import Grid from '@mui/material/Grid2'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { map } from 'lodash'
import { useNavigate } from 'react-router-dom'
import { ProjectItem } from '../../../../components/ProjectItem'
import { RecordImage } from '../../../../components/RecordImage/RecordImage'
import { RecordItemMenu } from './RecordItemMenu'

export const RecordListCard = ({ records }) => {
    const navigate = useNavigate()

    return (
        <>
            {map(records.objects, (record) => {
                const { workplace_id, created_at, id } = record

                const title = record.title?.length > 0 ? record.title : 'Название записи'
                return (
                    <Grid
                        size={{ xs: 12, sm: 12, md: 6, lg: 3 }}
                        sx={{
                            margin: 0,
                            p: 1,
                            mb: 0.5,
                            position: 'relative',
                            '&:hover #cellBoxLengthTypo': {
                                visibility: 'visible',
                            },
                            '& #cellBoxLengthTypo': { visibility: 'hidden' },
                        }}
                        key={id}>
                        <Paper
                            className={'Paper-primary'}
                            sx={{
                                textAlign: 'left',
                                position: 'relative',
                                display: 'flex',
                                flexDirection: 'column',
                            }}>
                            <RecordItemMenu record={record} isList={true} />
                            <div
                                style={{ cursor: 'pointer' }}
                                onClick={() => navigate(`/record/${id}`)}>
                                <RecordImage record={record} isList={true} />
                            </div>

                            <Typography
                                variant="caption2"
                                sx={{
                                    mr: '20px',
                                    py: 1,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }}>
                                {title}
                            </Typography>
                            <ProjectItem projectId={workplace_id} />
                        </Paper>
                    </Grid>
                )
            })}
        </>
    )
}
